import React from 'react';
import { Link } from 'react-router-dom';
import { outcomeMessage } from './outcomeMessage';
import { Hint, Title } from '../TurnBanner/styled';

const GameOver = ({ game, userId }) => {
  const outcome = outcomeMessage(game, userId);

  if (!outcome) {
    return null;
  }

  return (
    <div role="status">
      <Title>{outcome.title}</Title>
      <Hint>{outcome.detail} <Link to="/games">Back to games</Link></Hint>
    </div>
  );
};

export default GameOver;
